import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProductMatrix from './pages/ProductMatrixNew';
import Layout from './components/Layout';
import { ThemeProvider } from './contexts/ThemeContext';
import { ProductMatrixProvider } from './contexts/ProductMatrixContext';

function App() {
  return (
    <ThemeProvider defaultTheme="system" storageKey="shift4-theme">
      <ProductMatrixProvider>
        <Router>
          <Layout>
            <Routes>
              {/* All routes handled by ProductMatrix component */}
              <Route path="/" element={<ProductMatrix />} />
              <Route path="/location" element={<ProductMatrix />} />
              <Route path="/location/:region" element={<ProductMatrix />} />
              <Route path="/location/:region/:country" element={<ProductMatrix />} />
              <Route path="/browse" element={<ProductMatrix />} />
              <Route path="/platform/:platformName" element={<ProductMatrix />} />
              <Route path="/onboarding" element={<ProductMatrix />} />
              <Route path="/onboarding/:countryCode" element={<ProductMatrix />} />
            </Routes>
          </Layout>
        </Router>
      </ProductMatrixProvider>
    </ThemeProvider>
  );
}

export default App;